import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { OrderApiService } from 'src/app/services/api/order-api.service';

@Component({
  selector: 'app-repair-time-label',
  templateUrl: './repair-time-label.component.html',
  styleUrls: ['./repair-time-label.component.scss'],
})
export class RepairTimeLabelComponent implements OnChanges {
  @Input() data: any;
  repair_logs: any = null;
  constructor(private api: OrderApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.getRepairTime();
  }

  loading = false;
  async getRepairTime() {
    try {
      this.loading = true;
      const r = await this.api.getRepairTime(this.data.id);
      this.repair_logs = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
